module.exports = __webpack_public_path__ + "static/media/bh-3.767dfb93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/bh-3.jpg
// module id = 121
// module chunks = 0